import { render, staticRenderFns } from "./firmar-formato1-snp.vue?vue&type=template&id=16684d50&"
import script from "./firmar-formato1-snp.component.ts?vue&type=script&lang=ts&"
export * from "./firmar-formato1-snp.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports